module.exports = __webpack_public_path__ + "static/media/5.ea09607d.JPG";